
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { auth } from "./firebase";

export default defineComponent({
  name: "AppComp",
  data() {
    return {
      signedIn: false
    };
  },
  computed: {
    ...mapState(["userProfile"])
  },
  watch: {
    userProfile() {
      this.signedIn = auth.currentUser !== null;
    }
  }
});
